module.exports = __webpack_public_path__ + "img/ic_ppt.4f77a42e.svg";